const Profiletabs = {
    admin: [
        "Profile", "Investigations", "Examination", "Treatment", "Prescription",
        "Files", "Bills", "Payments", "Ledger", "Appointments", "Notes", "Followup"
    ],
    // admin: [
    //     "Profile", "Investigations", "Examination", "Treatment", "Prescription",
    //     "Files", "Appointments", "Notes", "Followup"
    // ],
    doctor: [
        "Profile", "Investigations", "Examination", "Treatment", "Prescription",
        "Files", "Appointments", "Notes", "Followup"
    ],
    receptionist: [
        "Profile", "Appointments", "Notes", "Followup", "Bills", "Payments"
    ],
    lab: [
        "Profile", "Investigations", "Files"
    ],
};


export {Profiletabs}